export default __webpack_public_path__ + "static/media/warning--added-lane-from-entering-roadway--g2.6c2e69cb.png";